import { motion } from "framer-motion";
import React from "react";

function Github() {
  return (
    <>
      <motion.svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        whileHover={{ scale: 1.1 }}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2ZM0 12C0 5.3726 5.3726 0 12 0C18.6274 0 24 5.3726 24 12C24 18.6274 18.6274 24 12 24C5.3726 24 0 18.6274 0 12Z"
          fill="#F5E7DE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5915 22.7358C9.4948 22.6109 9.4948 21.4986 9.5915 19.399C8.5556 19.4348 7.9011 19.3629 7.628 19.1833C7.2184 18.914 6.8083 18.0833 6.44445 17.4979C6.0806 16.9125 5.273 16.82 4.9469 16.6891C4.62079 16.5582 4.53892 16.0248 5.8455 16.4282C7.1521 16.8317 7.2158 17.9303 7.628 18.1872C8.0402 18.4441 9.0256 18.3317 9.4723 18.1259C9.91895 17.9201 9.8861 17.1539 9.96575 16.8503C10.0664 16.567 9.7115 16.5041 9.7037 16.5018C9.26765 16.5018 6.97685 16.0036 6.3476 13.7853C5.7184 11.567 6.52895 10.117 6.96135 9.49375C7.2496 9.0782 7.2241 8.1926 6.88485 6.83685C8.11665 6.67945 9.0672 7.06715 9.7366 8.00005C9.73725 8.0054 10.6141 7.4786 12 7.4786C13.3859 7.4786 13.8775 7.9077 14.257 8.00005C14.6364 8.0924 14.9399 6.36705 17.2833 6.83685C16.794 7.79845 16.3843 9.00005 16.697 9.49375C17.0097 9.98745 18.2371 11.5573 17.4832 13.7853C16.9805 15.2706 15.9925 16.1761 14.5191 16.5018C14.3501 16.5557 14.2656 16.6427 14.2656 16.7627C14.2656 16.9428 14.494 16.9624 14.8231 17.8058C15.0425 18.3681 15.0583 19.974 14.8706 22.6235C14.3952 22.7445 14.0253 22.8258 13.7609 22.8673C13.2922 22.941 12.7833 22.9823 12.2833 22.9982C11.7833 23.0142 11.6096 23.0124 10.9184 22.948C10.4575 22.9051 10.0152 22.8344 9.5915 22.7358Z"
          fill="#F5E7DE"
        />
      </motion.svg>
    </>
  );
}

export { Github };
